import React, { useState, useEffect, useCallback } from "react";
import { Outlet, useNavigate } from "react-router-dom";

// MUI
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Toolbar from "@mui/material/Toolbar";
import Drawer from "@mui/material/Drawer";

// Hooks
import { useAppSelector } from "../../redux/hooks/redux-hooks";

// components
import AdminHeader from "./header";
import AdminSidebar from "./sidebar";

const AdminLayout = () => {
  const navigate = useNavigate();
  const [mobileOpen, setMobileOpen] = useState(false);

  const loggedInUser = useAppSelector((state) => state.user.loggedIn_User);

  // Redirect to user pages for user login
  useEffect(() => {
    if (loggedInUser.loggedIn && loggedInUser.roleId !== 7) {
      navigate("/", { replace: true });
    }
  }, [loggedInUser, navigate]);

  // To show sidebar on click for mobile view
  const handleDrawerToggle = useCallback(() => {
    setMobileOpen(!mobileOpen);
  }, [mobileOpen]);

  return (
    <Box sx={{ display: "flex", height: "100vh", overflow: "auto" }}>
      <CssBaseline />
      <AdminHeader handleDrawerToggle={handleDrawerToggle} />
      <Drawer
        variant="temporary"
        open={mobileOpen}
        onClose={handleDrawerToggle}
        ModalProps={{
          keepMounted: true,
        }}
        sx={{
          display: { xs: "block", sm: "none" },
          "& .MuiDrawer-paper": { boxSizing: "border-box", width: "240px" },
        }}
      >
        <AdminSidebar handleDrawerToggle={handleDrawerToggle} />
      </Drawer>
      <Drawer
        sx={{
          width: "240px",
          display: { xs: "none", sm: "block" },
          "& .MuiDrawer-paper": {
            width: "240px",
            boxSizing: "border-box",
          },
        }}
        variant="permanent"
        anchor="left"
      >
        <AdminSidebar />
      </Drawer>
      <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
        <Toolbar />
        {<Outlet />}
      </Box>
    </Box>
  );
};

export default AdminLayout;
